import {
    CodeBlock,
    BlockType,
    SettingType,
    ValidationMessage,
    ValidationMessageType,
    SettingState,
    TibboDataType,
    IOLinesMode,
    IOMode,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_00_2 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_00_2';
        this.name = 'Tibbit 00_2';
        this.lines = 3;
        this.mode = IOMode.IO;
        this.initLines();
    }
}
